// De keuzes in de kolom 'VAST GEGEVEN' van de formulierbouwer: aan welk vast
// gegeven van het huishouden een vraag gekoppeld is. Nodig omdat de bouwer
// anders zelf de lijst en de 'al gebruikt'-regel moet kennen; één vraag per vast
// gegeven, anders overschrijft de laatste stil de eerste.
// AI-CONTEXT: See docs/features/huishouden-vaste-gegevens.md (T13)

import { HOUSEHOLD_FIELDS } from '../adressHelpers/householdFields'

/**
 * @typedef {object} FixedFieldChoice
 * @property {string} value - Sleutel uit HOUSEHOLD_FIELDS, of '' voor 'niet gekoppeld'
 * @property {string} label - Wat de beheerder ziet
 * @property {boolean} disabled - Al gekoppeld aan een andere vraag
 */

/**
 * @param {Array<{ID?: string, FixedFieldKey?: string}>} fields - De vragen van dit formulier
 * @param {string} currentFieldId - De vraag waarvoor de keuzes zijn
 * @returns {Array<FixedFieldChoice>}
 */
const fixedFieldChoices = (fields, currentFieldId) => {
    const taken = new Set((Array.isArray(fields) ? fields : [])
        .filter((field) => field?.ID !== currentFieldId && field?.FixedFieldKey)
        .map((field) => field.FixedFieldKey))

    return [
        { value: '', label: 'Niet gekoppeld', disabled: false },
        ...Object.entries(HOUSEHOLD_FIELDS).map(([key, def]) => ({ value: key, label: def.label, disabled: taken.has(key) })),
    ]
}

export default fixedFieldChoices
